<template>
  <div class="level-item overlay-buttons">
    <b-field grouped position="is-centered">
      <b-tooltip v-if="clientRole == 'host'" :label="localMute ? $t('unmuteDesc') : $t('muteDesc')" multilined animated>
        <b-button
          class="mr-2"
          size="is-medium"
          :icon-right="localMute ? 'microphone-off' : 'microphone'"
          :type="localMute ? 'is-danger is-light' : ''"
          @click="$emit('toggle-mute')"
        />
      </b-tooltip>
      <b-tooltip
        v-if="!isTranslator && clientRole == 'host'"
        :label="localVideoMute ? $t('unmuteVideoDesc') : $t('muteVideoDesc')"
        multilined
        animated
      >
        <b-button
          class="mr-2"
          size="is-medium"
          :type="localVideoMute ? 'is-danger is-light' : ''"
          :icon-right="localVideoMute ? 'video-off' : 'video'"
          @click="$emit('toggle-video-mute')"
        />
      </b-tooltip>
      <b-tooltip
        v-if="!isTranslator && clientRole == 'host'"
        :label="handRaised ? $t('unraiseHandDesc') : $t('raiseHandDesc')"
        multilined
        animated
      >
        <b-button
          class="mr-2"
          size="is-medium"
          :type="handRaised ? 'is-warning' : ''"
          icon-right="hand-right"
          @click="$emit('toggle-raiseHand')"
        />
      </b-tooltip>
      <b-tooltip
        v-if="!isTranslator && supportsScreenShare && clientRole == 'host'"
        :label="sharing ? $t('stopShareScreenDesc') : $t('shareScreenDesc')"
        multilined
        animated
      >
        <b-button
          class="mr-2"
          size="is-medium"
          :icon-right="sharing ? 'monitor-off' : 'monitor-share'"
          :type="sharing ? 'is-danger' : ''"
          @click="$emit('toggle-screen')"
        />
      </b-tooltip>
      <b-tooltip
        v-if="reqToSpeakMode && clientRole == 'audience' && !allowedToSpeak"
        :label="$t('switchToSpeakerDesc')"
        multilined
        animated
      >
        <b-button class="mr-2" size="is-medium" icon-left="microphone" @click="$emit('request-switch-to-host')">
          {{ reqToSpeakOngoing ? $t("pendingToSwitchToSpeaker") : $t("requestToSwitchToSpeaker") }}
        </b-button>
      </b-tooltip>
      <b-tooltip
        v-if="allowedToSpeak && clientRole == 'audience'"
        :label="$t('switchToSpeakerDesc')"
        multilined
        animated
      >
        <b-button class="mr-2 startSpeakBtn" size="is-medium" icon-left="microphone" @click="$emit('switch-to-host')">
          {{ $t("switchToSpeaker") }}
        </b-button>
      </b-tooltip>
      <b-tooltip :label="$t('hangupDesc')" multilined animated>
        <!--
          trigered on click
          @event click
          @property {object} demo - example
          @property {number} called - test called
        -->
        <b-button type="is-danger" size="is-medium" icon-right="phone-hangup" @click="$emit('leave')" />
      </b-tooltip>
      <!-- <b-tooltip :label="$t('hangupDesc')" multilined animated>
        <b-button
          type="is-danger"
          size="is-medium"
          icon-right="microphone"
          @click="$emit('networkthrottle')"
        />
      </b-tooltip>
      <b-tooltip :label="$t('hangupDesc')" multilined animated>
        <b-button
          type="is-danger"
          size="is-medium"
          icon-right="microphone"
          @click="$emit('resetnetworkthrottle')"
        />
      </b-tooltip> -->
    </b-field>
  </div>
</template>

<script>
/**
 * Buttons for user side control
 * Host: can un-/mute Mic, en-/disable Camera, raise Hand, start Presentation, Leave
 * Viewer: can request to speak, leave
 * @displayName Basic Buttons
 */
export default {
  name: "BasicButtons",
  props: {
    /**
     * Indicates whether a request to speak was send to moderator
     */
    reqToSpeakOngoing: {
      type: Boolean,
      default: false,
    },
    /**
     * Indicates whether the Viewer is allowed to speak
     */
    reqToSpeakMode: {
      type: Boolean,
      default: false,
    },
    /**
     * Status for hand raised.
     */
    handRaised: {
      type: Boolean,
      default: false,
    },
    /**
     * Client Role
     */
    clientRole: {
      type: String,
      default: "host",
    },
    /**
     * If user is translator.
     */
    isTranslator: {
      type: Boolean,
      default: false,
    },
    /**
     * User Mic status
     */
    localMute: {
      type: Boolean,
      default: false,
    },
    /**
     * User video status
     */
    localVideoMute: {
      type: Boolean,
      default: false,
    },
    /**
     * Whether user or browser is able to share screen
     */
    supportsScreenShare: {
      type: Boolean,
      default: false,
    },
    /**
     * Is viewer allow to speak and join as host
     */
    allowedToSpeak: {
      type: Boolean,
      default: false,
    },
    /**
     * Screen sharing status.
     */
    sharing: {
      type: Boolean,
      defaul: false,
    },
  },
};
</script>

<style>
.overlay-buttons {
  position: absolute;
  z-index: 4;
  bottom: 24px;
  left: 50%;
  transform: translateX(-50%);
  opacity: 1;
  transition: all 0.25s ease;
}

.overlay-buttons:hover {
  opacity: 1;
}

.overlay-buttons button,
.overlay-buttons button:focus,
.overlay-buttons button.is-focused {
  background: transparent;
  border-width: 2px;
  border-style: solid;
  border-radius: 25px;
  color: #fff;
  border-color: #fff;
  box-shadow: none !important;
}

.overlay-buttons button.is-light,
.overlay-buttons button.is-light:focus,
.overlay-buttons button.is-light.is-focused {
  background: transparent;
}

.overlay-buttons button.is-danger:not(.is-light),
.overlay-buttons button.is-danger:focus:not(.is-light),
.overlay-buttons button.is-danger:not(.is-light).is-focused {
  border-color: #f14668;
}

.overlay-buttons button.is-danger.is-light,
.overlay-buttons button.is-danger.is-light:focus,
.overlay-buttons button.is-danger.is-light.is-focused {
  border-color: #fff;
  background: transparent;
  color: #f14668;
}

.overlay-buttons:hover button,
.overlay-buttons:hover button:focus,
.overlay-buttons:hover button.is-focused {
  background: #ffffff;
  border-color: #cccccc;
  color: #333333;
}

.overlay-buttons:hover button.is-danger:not(.is-light),
.overlay-buttons:hover button.is-danger:focus:not(.is-light),
.overlay-buttons:hover button.is-danger.is-focused:not(.is-light) {
  background: #f14668;
  color: #fff;
}

.overlay-buttons:hover button.is-warning:not(.is-light),
.overlay-buttons:hover button.is-warning:focus:not(.is-light),
.overlay-buttons button.is-warning:focus:not(.is-light),
.overlay-buttons:hover button.is-warning.is-focused:not(.is-light),
.overlay-buttons button.is-warning.is-focused:not(.is-light) {
  background: #ffdd57;
  color: rgba(0, 0, 0, 0.7);
}

.startSpeakBtn {
  animation-name: example;
  animation-duration: 3s;
  animation-iteration-count: infinite;
}

@keyframes example {
  0% {
    border-color: red;
  }
  25% {
    border-color: yellow;
  }
  50% {
    border-color: blue;
  }
  100% {
    border-color: green;
  }
}
</style>
